'use client'

import Cookies from 'js-cookie'
import { LINKEDIN_CLICK_ID_COOKIE, parseLinkedInClickId } from '@/utils/linkedinAttribution'
import { useEffect } from 'react'
import { useSearchParams } from 'next/navigation'

/**
 * Captures ad click IDs from the URL and persists them as 90-day cookies:
 * - `gclid`  — Google Ads click ID
 * - `oppref` — OpenAI / ChatGPT Ads click ID
 * - `li_fat_id` — LinkedIn Ads click ID
 *
 * The cookies are read by useHubSpotForm.ts / marketplaceFormHelpers.ts and
 * injected into HubSpot form hidden fields, enabling offline conversion
 * tracking (Salesforce → Google Ads import; OpenAI Conversions API).
 *
 * Must be wrapped in <Suspense> because useSearchParams() opts into
 * client-side rendering in Next.js App Router.
 */
export default function GclidTracker() {
  const searchParams = useSearchParams()
  const gclid = searchParams.get('gclid')
  const oppref = searchParams.get('oppref')
  const liFatId = searchParams.get('li_fat_id')

  useEffect(() => {
    const value = gclid?.trim()
    if (value && value.length <= 256) {
      Cookies.set('gclid', value, { expires: 90 })
    }
  }, [gclid])

  useEffect(() => {
    const value = oppref?.trim()
    if (value && value.length <= 256) {
      Cookies.set('oppref', value, { expires: 90 })
    }
  }, [oppref])

  useEffect(() => {
    const value = parseLinkedInClickId(liFatId)
    if (value) {
      Cookies.set(LINKEDIN_CLICK_ID_COOKIE, value, { expires: 90 })
    }
  }, [liFatId])

  return null
}
